import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NewLanding from "./pages/NewLanding";
import { useEffect } from "react";
import Testimonial from "./pages/Testimonial";
import TestimonialVideo from "./pages/TestimonialVideo";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ProjectNew from "./pages/ProjectNew";

function App() {
  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
      });
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<NewLanding />} />
          <Route path="/testimonials" element={<Testimonial />} />
          <Route path="/testimonials-video" element={<TestimonialVideo />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects/:category?" element={<ProjectNew />} />
          <Route path="/contact-us" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
